import React from 'react';
import useAccessibleClick from '../../../../common/hooks/useAccessibleClick';

const Tab = ({ children, onClick, className, inputRef = null }) => {
  const ref = useAccessibleClick(onClick, inputRef);
  return (
    <div ref={ref} tabIndex={0} onClick={onClick} className={className}>
      {children}
    </div>
  );
};

export default Tab;
